import { useTranslation } from "react-i18next";
import { NavLink, Outlet, useLocation, useParams } from "react-router-dom";
import { Header } from "../../components/Header";
import { useAppStore } from "../../stores/RootStore";
import { Separator } from "../../ui/Separator";
import StaffGrid from "./StaffGrid";

export const Staff = () => {
  let {id} = useParams();
  const { t } = useTranslation();
  const location = useLocation();
  const currentSite = useAppStore().currentSite
  const persons = useAppStore().persons;
  let person = persons?.find(n => n.id == id)

  function empty() {}

  return (
    <div className="flex flex-col w-full h-full bg-muted">
      <div className="flex-none flex w-full h-14 px-6 justify-between items-center bg-background">
        <div className="flex text-base items-center gap-1">
          <NavLink to={"/"}><span className="font-medium">{currentSite?.name ? currentSite?.name : "..."}</span></NavLink>
          <span>/</span>
          {location.pathname == "/data/staff/" || location.pathname == "/data/staff" ? <span className="font-medium">{t("staff")}</span> : <NavLink to={"/data/staff"}><span className="font-medium">{t("staff")}</span></NavLink>}
          {(id || location.pathname == "/data/staff/new") && <span>/</span>}
          {id && <span>{person?.attributes.last_name} {person?.attributes.first_name} {person?.attributes.middle_name}</span>}
          {location.pathname == "/data/staff/new" && <span>{t('adding_staff')}</span>}
        </div>
      </div>
      <Separator className="flex-none"/>
      {id || location.pathname == "/data/staff/new" ? 
        <Outlet /> : 
        <div className="flex w-full h-full bg-background">
          <div className="flex flex-col w-full h-full mx-auto overflow-hidden">
            <Header name={t('staff')} backName={currentSite?.name ? currentSite?.name : "..."} backLink={"/"}/>
            <StaffGrid onClose={empty}/>
          </div>
        </div>
      }
    </div>
  )
};
